import { Component, Inject, OnInit } from '@angular/core';
import { formatDate } from '@angular/common';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { DigisubservicesService } from '../services/digisubservices.service';
import * as XLSX from 'xlsx';

@Component({
  selector: 'app-book-seller-print-order-statement',
  templateUrl: './book-seller-print-order-statement.component.html',
  styleUrls: ['./book-seller-print-order-statement.component.scss']
})
export class BookSellerPrintOrderStatementComponent implements OnInit {

    today = new Date();

  startDate!: Date;
  endDate!: Date;

  totalprati = 0;
  totalpsankhya = 0;

  book_name = '';
  publishyear: any;

  saving = false;

  tempdata: any[] = [
    { no: 1, name: 'नोंदणी', prati: 0, shera: '', auto: true },
    { no: 2, name: 'लेखक सप्रेम भेट', prati: 0, shera: '', auto: false },
    { no: 3, name: 'सप्रेम भेट', prati: 0, shera: '', auto: false },
    { no: 4, name: 'जादा', prati: 0, shera: '', auto: false }
  ];

  constructor(
    private service: DigisubservicesService,
    private dialogRef: MatDialogRef<BookSellerPrintOrderStatementComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {}

  ngOnInit(): void {

    console.log('RECEIVED DATA =>', this.data);

    this.book_name = this.data?.bookwise || '';

    if (this.data?.issuedate) {

      const issueDay = new Date(this.data.issuedate);
      this.endDate = issueDay;

      const weekFirstDay = issueDay.getDate() - issueDay.getDay();
      const start = new Date(issueDay);
      start.setDate(weekFirstDay - 6);

      this.startDate = start;
    }

    this.getPrintOrderData();
  }

  // ================= API =================
  getPrintOrderData() {

    const payload = { ...this.data };

    this.service.getissuesPrintOrderData1(payload)
      .subscribe((res: any) => {

        console.log('API =>', res);

        if (res.status && res.data?.length) {

          const totalCopies = res.data.reduce(
            (sum: number, b: any) => sum + Number(b.book_copies || 0),
            0
          );

          this.tempdata[0].prati = totalCopies;

          this.publishyear = res.data[0]?.publishyear;

          this.totalPrati();
        }
      });
  }

  // ================= TOTAL =================
  totalPrati() {
    this.totalprati = this.tempdata.reduce(
      (sum, i) => sum + Number(i.prati || 0),
      0
    );
  }

  // ================= ADD ROW =================
  addNewtempdata() {

    this.tempdata.push({
      no: this.tempdata.length + 1,
      name: '',
      prati: 0,
      shera: '',
      auto: false
    });
  }

  // ================= EXPORT =================
  exportexcel(fileName: string): void {

    const element = document.getElementById('print-section');
    const ws: XLSX.WorkSheet = XLSX.utils.table_to_sheet(element);
    const wb: XLSX.WorkBook = XLSX.utils.book_new();

    XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');
    XLSX.writeFile(wb, fileName + '.xlsx');
  }

  // ================= SAVE =================
  save() {

    if (!this.book_name) {
      alert('पुस्तकाचे नाव आवश्यक आहे');
      return;
    }

    const publishDate = this.publishyear ? new Date(this.publishyear) : null;

    const payload = {
      book_name: this.book_name,
      adesh_date: formatDate(this.today, 'yyyy-MM-dd', 'en-IN'),
      publish_date: publishDate
        ? formatDate(publishDate, 'yyyy-MM-dd', 'en-IN')
        : null,

      total_copies: this.totalprati,
      ekun_prushth: this.totalpsankhya,

      items: this.tempdata.map(i => ({
        no: i.no,
        name: i.name,
        copies: i.prati,
        remarks: i.shera || ''
      }))
    };

    console.log('FINAL PAYLOAD =>', payload);

    this.saving = true;

    this.service.savePrintOrder(payload)
      .subscribe({
        next: (res: any) => {
          this.saving = false;

          if (res.success) {
            alert('Saved successfully');
            this.dialogRef.close(true);
          } else {
            alert(res.msg || 'Save failed');
          }
        },
        error: (err) => {
          this.saving = false;
          console.error(err);
          alert('Server error');
        }
      });
  }

  // ================= CLOSE =================
  closeDialog() {
    this.dialogRef.close();
  }
}